import React, { useState } from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { Input } from '../components/ui/Input';
import { Search, Download, Upload, ShoppingCart, CheckSquare, Square } from 'lucide-react';
interface BulkOrderProps {
  onNavigate: (page: string) => void;
}
interface Product {
  id: string;
  sku: string;
  name: string;
  price: number;
  unit: string;
  moq: number;
  stock: string;
  selected: boolean;
  quantity: number;
}
export function BulkOrder({
  onNavigate
}: BulkOrderProps) {
  const [products, setProducts] = useState<Product[]>([{
    id: '1',
    sku: 'SKU-MG-001',
    name: 'Minyak Goreng Sania 2L',
    price: 35000,
    unit: 'Pouch',
    moq: 12,
    stock: 'Tersedia',
    selected: false,
    quantity: 12
  }, {
    id: '2',
    sku: 'SKU-GL-002',
    name: 'Gula Pasir Gulaku 1kg',
    price: 14500,
    unit: 'Pack',
    moq: 24,
    stock: 'Tersedia',
    selected: false,
    quantity: 24
  }, {
    id: '3',
    sku: 'SKU-IM-003',
    name: 'Indomie Goreng Special',
    price: 3100,
    unit: 'Pcs',
    moq: 40,
    stock: 'Terbatas',
    selected: false,
    quantity: 40
  }, {
    id: '4',
    sku: 'SKU-KP-004',
    name: 'Kopi Kapal Api Special',
    price: 12000,
    unit: 'Pack',
    moq: 10,
    stock: 'Tersedia',
    selected: false,
    quantity: 10
  }, {
    id: '5',
    sku: 'SKU-SB-005',
    name: 'Sabun Lifebuoy Cair 500ml',
    price: 22000,
    unit: 'Botol',
    moq: 6,
    stock: 'Tersedia',
    selected: false,
    quantity: 6
  }, {
    id: '6',
    sku: 'SKU-TG-006',
    name: 'Tepung Terigu Segitiga 1kg',
    price: 11000,
    unit: 'Pack',
    moq: 20,
    stock: 'Tersedia',
    selected: false,
    quantity: 20
  }, {
    id: '7',
    sku: 'SKU-BR-007',
    name: 'Beras Ramos 5kg',
    price: 65000,
    unit: 'Karung',
    moq: 10,
    stock: 'Tersedia',
    selected: false,
    quantity: 10
  }, {
    id: '8',
    sku: 'SKU-AQ-008',
    name: 'Aqua Galon 19L',
    price: 19500,
    unit: 'Galon',
    moq: 5,
    stock: 'Tersedia',
    selected: false,
    quantity: 5
  }]);
  const [selectAll, setSelectAll] = useState(false);
  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
    setProducts(products.map(p => ({
      ...p,
      selected: !selectAll
    })));
  };
  const toggleSelect = (id: string) => {
    setProducts(products.map(p => p.id === id ? {
      ...p,
      selected: !p.selected
    } : p));
  };
  const updateQuantity = (id: string, quantity: number) => {
    setProducts(products.map(p => p.id === id ? {
      ...p,
      quantity: Math.max(p.moq, quantity)
    } : p));
  };
  const selectedProducts = products.filter(p => p.selected);
  const totalItems = selectedProducts.reduce((sum, p) => sum + p.quantity, 0);
  const totalValue = selectedProducts.reduce((sum, p) => sum + p.quantity * p.price, 0);
  return <div className="space-y-6" data-id="element-1279">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-1280">
        <div data-id="element-1281">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-1282">
            Pemesanan Massal
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-1283">
            Pilih dan pesan banyak produk sekaligus dengan mudah
          </p>
        </div>
        <div className="flex gap-2" data-id="element-1284">
          <Button variant="outline" icon={<Download className="w-4 h-4" data-id="element-1286" />} data-id="element-1285">
            Unduh Template
          </Button>
          <Button variant="outline" icon={<Upload className="w-4 h-4" data-id="element-1288" />} data-id="element-1287">
            Import Excel
          </Button>
        </div>
      </div>

      {/* Search */}
      <div className="relative" data-id="element-1289">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" data-id="element-1290" />
        <input type="text" placeholder="Cari produk berdasarkan nama atau SKU..." className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white" data-id="element-1291" />
      </div>

      {/* Bulk Actions Bar */}
      {selectedProducts.length > 0 && <Card className="p-4 bg-blue-50 border-blue-200" data-id="element-1292">
          <div className="flex items-center justify-between" data-id="element-1293">
            <div className="flex items-center gap-4" data-id="element-1294">
              <span className="font-bold text-blue-900" data-id="element-1295">
                {selectedProducts.length} produk dipilih
              </span>
              <span className="text-sm text-blue-700" data-id="element-1296">
                Total: {totalItems} unit • Rp{' '}
                {totalValue.toLocaleString('id-ID')}
              </span>
            </div>
            <div className="flex gap-2" data-id="element-1297">
              <Button variant="outline" size="sm" onClick={() => setProducts(products.map(p => ({
            ...p,
            selected: false
          })))} data-id="element-1298">
                Batal Pilih
              </Button>
              <Button variant="primary" size="sm" icon={<ShoppingCart className="w-4 h-4" data-id="element-1300" />} onClick={() => onNavigate('checkout')} data-id="element-1299">
                Tambah ke Keranjang
              </Button>
            </div>
          </div>
        </Card>}

      {/* Product Table */}
      <Card className="overflow-hidden" data-id="element-1301">
        <div className="overflow-x-auto" data-id="element-1302">
          <table className="w-full" data-id="element-1303">
            <thead className="bg-slate-50 border-b border-slate-200" data-id="element-1304">
              <tr data-id="element-1305">
                <th className="px-4 py-3 text-left" data-id="element-1306">
                  <button onClick={toggleSelectAll} className="flex items-center gap-2 text-slate-700 hover:text-slate-900" data-id="element-1307">
                    {selectAll ? <CheckSquare className="w-5 h-5 text-blue-600" data-id="element-1308" /> : <Square className="w-5 h-5" data-id="element-1309" />}
                  </button>
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-slate-700" data-id="element-1310">
                  SKU
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-slate-700" data-id="element-1311">
                  Nama Produk
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-slate-700" data-id="element-1312">
                  Harga Satuan
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-slate-700" data-id="element-1313">
                  MOQ
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-slate-700" data-id="element-1314">
                  Stok
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-slate-700" data-id="element-1315">
                  Jumlah
                </th>
                <th className="px-4 py-3 text-right text-sm font-bold text-slate-700" data-id="element-1316">
                  Subtotal
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-1317">
              {products.map(product => <tr key={product.id} className={`hover:bg-slate-50 transition-colors ${product.selected ? 'bg-blue-50' : ''}`} data-id="element-1318">
                  <td className="px-4 py-4" data-id="element-1319">
                    <button onClick={() => toggleSelect(product.id)} data-id="element-1320">
                      {product.selected ? <CheckSquare className="w-5 h-5 text-blue-600" data-id="element-1321" /> : <Square className="w-5 h-5 text-slate-400" data-id="element-1322" />}
                    </button>
                  </td>
                  <td className="px-4 py-4" data-id="element-1323">
                    <span className="text-xs font-mono text-slate-600" data-id="element-1324">
                      {product.sku}
                    </span>
                  </td>
                  <td className="px-4 py-4" data-id="element-1325">
                    <span className="font-medium text-slate-900" data-id="element-1326">
                      {product.name}
                    </span>
                  </td>
                  <td className="px-4 py-4" data-id="element-1327">
                    <span className="font-bold text-blue-600" data-id="element-1328">
                      Rp {product.price.toLocaleString('id-ID')}
                      <span className="text-xs text-slate-400 font-normal ml-1" data-id="element-1329">
                        /{product.unit}
                      </span>
                    </span>
                  </td>
                  <td className="px-4 py-4" data-id="element-1330">
                    <span className="text-sm text-slate-600" data-id="element-1331">
                      {product.moq} {product.unit}
                    </span>
                  </td>
                  <td className="px-4 py-4" data-id="element-1332">
                    <Badge variant={product.stock === 'Tersedia' ? 'success' : 'warning'} data-id="element-1333">
                      {product.stock}
                    </Badge>
                  </td>
                  <td className="px-4 py-4" data-id="element-1334">
                    <input type="number" value={product.quantity} onChange={e => updateQuantity(product.id, parseInt(e.target.value) || product.moq)} min={product.moq} step={product.moq} className="w-24 px-3 py-2 border border-slate-200 rounded-lg text-sm text-center focus:outline-none focus:ring-2 focus:ring-blue-500" disabled={!product.selected} data-id="element-1335" />
                  </td>
                  <td className="px-4 py-4 text-right" data-id="element-1336">
                    <span className="font-bold text-slate-900" data-id="element-1337">
                      Rp{' '}
                      {(product.quantity * product.price).toLocaleString('id-ID')}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Summary Footer */}
      <Card className="p-6 bg-slate-50 border-slate-200" data-id="element-1338">
        <div className="flex items-center justify-between" data-id="element-1339">
          <div data-id="element-1340">
            <p className="text-sm text-slate-600 mb-1" data-id="element-1341">Total yang Dipilih</p>
            <p className="text-2xl font-bold text-slate-900" data-id="element-1342">
              {selectedProducts.length} produk • {totalItems} unit
            </p>
          </div>
          <div className="text-right" data-id="element-1343">
            <p className="text-sm text-slate-600 mb-1" data-id="element-1344">Total Nilai</p>
            <p className="text-3xl font-extrabold text-blue-600" data-id="element-1345">
              Rp {totalValue.toLocaleString('id-ID')}
            </p>
          </div>
        </div>
      </Card>
    </div>;
}